<template>
  <div class="internal">
    <div class="container">
      <h1>Past Projects</h1>
      <hr />
      <div class="row testimonials-container">
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="odd">
            <div class="past-proj-img--1"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--2"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="odd">
            <div class="past-proj-img--3"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--4"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="odd">
            <div class="past-proj-img--5"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--6"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--7"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--8"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--9"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--10"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--11"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--12"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--13"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--14"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--15"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--16"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--17"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--18"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--19"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--20"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--21"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--22"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--23"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--24"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--25"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--26"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--27"></div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4 testimonial-wrapper">
          <div class="even">
            <div class="past-proj-img--28"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "past-projects",
};
</script>



// WEBPACK FOOTER //
// src/components/pages/PastProjects.vue